import React, { useState, useEffect, useCallback } from "react";
import { BiSearch } from "react-icons/bi";
import {
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  ModalFooter,
} from "reactstrap";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import "../trivia-survey.css";
import debounce from "lodash.debounce";
import ReactPlayer from "react-player";
import { Spinner } from "../../../utils/constants";
import CheckBox from "rc-checkbox";
import { connect } from "react-redux";
import * as actionCreators from "../../../modules/actions";
import withLoading from "../../../hoc/Loading/Loading";

function UploadMediaModal({
  open,
  onClose,
  setBannerImg,
  preloadedImages,
  preloadedGiphys,
  preloadedVideos,
  setPopularImages,
  setPopularVideos,
  setPopularGifs,
  selectedMedia,
  removeBannerImg,
}) {
  const [tab, setTab] = useState(1);
  const [apiImages, setApiImages] = useState([]);
  const [apiVideos, setApiVideos] = useState([]);
  const [apiGiphys, setApiGiphys] = useState([]);
  const [imageSearchInput, setImageSearchInput] = useState("");
  const [videoSearchInput, setVideoSearchInput] = useState("");
  const [giphySearchInput, setGiphySearchInput] = useState("");
  // const [uploadedFile, setUploadedFile] = useState(null);
  const [searching, setSearching] = useState(false);
  const [imagePage, setImagePage] = useState(1);
  const [giphyPage, setGiphyPage] = useState(1);
  const [videoPage, setVideoPage] = useState(1);

  useEffect(() => {
    if (preloadedImages && preloadedImages.length) {
      setApiImages(preloadedImages);
    }
  }, [preloadedImages]);
  useEffect(() => {
    if (preloadedVideos && preloadedVideos.length) {
      setApiVideos(preloadedVideos);
    }
  }, [preloadedVideos]);
  useEffect(() => {
    if (preloadedGiphys && preloadedGiphys.length) {
      setApiGiphys(preloadedGiphys);
    }
  }, [preloadedGiphys]);

  const preloadPopularImages = (cb, page = 1) => {
    axios
      .post(url.searchImages, {
        isPopular: true,
        noLoader: true,
        page: page,
      })
      .then(({ data }) => {
        if (cb) {
          cb(data.data.photos);
        } else {
          setApiImages([...apiImages, ...data.data.photos]);
        }
      });
  };
  const preloadPopularGifs = (cb, page = 1) => {
    axios
      .post(url.searchGiphy, {
        isPopular: true,
        noLoader: true,
        page: page,
      })
      .then(({ data }) => {
        if (cb) {
          cb(data.data.data);
        } else {
          setApiGiphys([...apiGiphys, ...data.data.data]);
        }
      });
  };

  console.log(apiGiphys);

  const preloadPopularVideos = (cb, page = 1) => {
    axios
      .post(url.searchVideos, {
        isPopular: true,
        noLoader: true,
        page: page,
      })
      .then(({ data }) => {
        if (cb) {
          cb(data.data.videos);
        } else {
          setApiVideos([...apiVideos, ...data.data.videos]);
        }
      });
  };

  const getImages = (imageSearch, page = 1) => {
    setSearching(true);
    axios
      .post(url.searchImages, {
        imageSearch: imageSearch,
        noLoader: true.valueOf,
        page,
      })
      .then(({ data }) => {
        setSearching(false);
        setApiImages([...apiImages, ...data.data.photos]);
      })
      .catch((e) => {
        setSearching(false);
      });
  };
  const getGifs = (giphySearch, page = 1) => {
    setSearching(true);
    axios
      .post(url.searchGiphy, { giphySearch: giphySearch, noLoader: true, page })
      .then(({ data }) => {
        setSearching(false);
        setApiGiphys([...apiGiphys, ...data.data.data]);
      })
      .catch((e) => {
        setSearching(false);
      });
  };

  const getVideos = (videoSearch, page = 1) => {
    setSearching(true);
    axios
      .post(url.searchVideos, {
        videoSearch: videoSearch,
        noLoader: true,
        page,
      })
      .then(({ data }) => {
        setSearching(false);
        setApiVideos([...apiVideos, ...data.data.videos]);
      })
      .catch((e) => {
        setSearching(false);
      });
  };

  const changeTab = (number) => {
    setTab(number);
  };

  useEffect(() => {
    setImagePage(1);
    setVideoPage(1);
    setGiphyPage(1);
    if (tab == 2) {
      if (apiImages.length && imageSearchInput.length) {
        //none
      } else {
        if (preloadedImages && preloadedImages.length) {
          setApiImages(preloadedImages);
        } else {
          preloadPopularImages(setPopularImages, 1);
        }
      }
    }
    if (tab == 3) {
      if (apiVideos.length && videoSearchInput.length) {
        //none
      } else {
        if (preloadedVideos && preloadedVideos.length) {
          setApiVideos(preloadedVideos);
        } else {
          preloadPopularVideos(setPopularVideos, 1);
        }
      }
    }
    if (tab == 4) {
      if (apiGiphys.length && giphySearchInput.length) {
        //none
      } else {
        if (preloadedGiphys && preloadedGiphys.length) {
          setApiGiphys(preloadedGiphys);
        } else {
          preloadPopularGifs(setPopularGifs, 1);
        }
      }
    }
  }, [tab]);

  const fileSelectedHandler = (e) => {
    const file = e.target.files[0];

    if (file && file.type && (file.type.indexOf("image") > -1 || file.type.indexOf("video") > -1)) {
      let obj = {
        name: file.name,
        type: file.type,
        size: file.size,
        file,
        datetime: Date.now().toString(),
        isUploaded: true,
        url: URL.createObjectURL(file),
      };
      setBannerImg(obj);
    }

    Array.from(e.target.files).map((file) => URL.revokeObjectURL(file));
  };

  const urlSelectHandlerImage = (data) => {
    setBannerImg({
      type: "image",
      url: data.src.landscape || data.src.original,
    });
  };

  const urlSelectHandlerVideo = (video) => {
    console.log(video);
    setBannerImg({
      type: video.file_type,
      url: video.link,
    });
  };
  const urlSelectHandlerGif = (data) => {
    setBannerImg({
      type: "gif",
      url: data.images.original.url,
    });
  };

  const debounceSearchImage = useCallback(debounce(getImages, 200), []);
  const debounceSearchVideos = useCallback(debounce(getVideos, 200), []);
  const debounceSearchGiphy = useCallback(debounce(getGifs, 200), []);

  const renderUploadPreview = (source, selectedImg) => {
    // let { bannerImg } = this.state;
    let mb = 1024 * 1024;
    return source.map((photo, idx) => {
      let url, alt, details, id, name;
      if (photo.isUploaded) {
        name = photo.name;
        // type: photo.type,
        // size: photo.size,

        details = `${photo.type} and size:${(photo.size / mb).toFixed(2)}mb`;
        // file
        url = photo.preview;
        id = photo.preview;
        // isAccepted:checkUploadType(file.type)
      } else {
        id = photo.id;
        details = photo.photographer;
        url = photo.src.landscape;
        // file={...photo.src}
        name = photo.alt;
      }

      return (
        <span
          key={idx}
          className="col-xs-6 col-md-6 col-lg-6 grp_baner_modal_image_item grp_baner_modal_container_2"
        >
          <span className={"storyUploadPreviewImg"}>
            <img src={url} className="fileUploadSize" />
            {/* <span key={id+idx} onClick={()=>this.removeImage(id)} className="removeTaskUpload">
					<span className='flaticon-trash'/></span> */}
            <CheckBox
              className="grp_baner_modal_image_checkbox"
              checked={selectedImg && selectedImg.url == url}
              type="checkbox"
              onClick={() => {
                urlSelectHandlerImage(photo);
              }}
            />
            <div className="grp_baner_modal_image_item_details">
              <span className="grp_baner_modal_image_item_details_title">
                {alt}
              </span>
              <span className="grp_baner_modal_image_item_details_author">
                {details}
              </span>
            </div>
          </span>
        </span>
      );
    });
  };

  const renderGiphysPreview = (source, selectedImg) => {
    return source.map((photo, idx) => {
      let url = photo.images && photo.images.original.url;

      return (
        <span
          key={idx}
          className="col-xs-6 col-md-6 col-lg-6 grp_baner_modal_image_item grp_baner_modal_container_2"
        >
          <span className={""}>
            <img src={url} className="fileUploadSize giphy-maodalheight" />
            {/* <span key={id+idx} onClick={()=>this.removeImage(id)} className="removeTaskUpload">
					<span className='flaticon-trash'/></span> */}
            <CheckBox
              className="grp_baner_modal_image_checkbox"
              checked={selectedImg && selectedImg.url == url}
              type="checkbox"
              onClick={() => {
                urlSelectHandlerGif(photo);
              }}
            />
          </span>
        </span>
      );
    });
  };

  const getPhotosUi = () => {
    const selectedImg =
      selectedMedia[0] &&
      !selectedMedia[0].uploaded &&
      selectedMedia[0].type &&
      selectedMedia[0].type.indexOf("image") > -1
        ? selectedMedia[0]
        : null;

    console.log(selectedMedia);
    return (
      <div>
        <div className="mb-3">
          <InputGroup>
            <InputGroupAddon
              addonType="prepend"
              className="input_img_vid_search_preprend"
            >
              <BiSearch />
            </InputGroupAddon>
            <Input
              placeholder={` Search "engineer", "professional", "manager", etc `}
              value={imageSearchInput}
              onChange={(e) => {
                setImageSearchInput(e.target.value);
                if (e.target.value.trim()) {
                  debounceSearchImage(e.target.value, 1);
                }
              }}
            />
          </InputGroup>

          {selectedImg && (
            <div className="my-3">
              {" "}
              <span className="grp_baner_selected_img_container">
                <img
                  src={selectedImg.url}
                  className="grp_baner_selected_img_preview"
                />
                <span
                  className="flaticon-trash"
                  onClick={() => removeBannerImg()}
                />
              </span>{" "}
            </div>
          )}
        </div>

        <div>
          {(!searching || imagePage > 1) && apiImages && apiImages.length ? (
            <div
              className="grp_baner_modal_image_container"
              style={{
                maxHeight: "none",
              }}
            >
              {renderUploadPreview(apiImages, selectedImg)}
            </div>
          ) : (
            <div className="d-flex justify-content-center">
              <img src={Spinner} height="100px" width="100px" />
            </div>
          )}
        </div>
      </div>
    );
  };

  const getGiphyUI = () => {
    const selectedImg =
      selectedMedia[0] &&
      !selectedMedia[0].uploaded &&
      selectedMedia[0].type &&
      selectedMedia[0].type.indexOf("gif") > -1
        ? selectedMedia[0]
        : null;

    console.log(selectedMedia);
    return (
      <div>
        <div className="mb-3">
          <InputGroup>
            <InputGroupAddon
              addonType="prepend"
              className="input_img_vid_search_preprend"
            >
              <BiSearch />
            </InputGroupAddon>
            <Input
              placeholder={` Search "car", "dog", "cat", etc `}
              value={giphySearchInput}
              onChange={(e) => {
                setGiphySearchInput(e.target.value);
                if (e.target.value.trim()) {
                  debounceSearchGiphy(e.target.value, 1);
                }
              }}
            />
          </InputGroup>

          {selectedImg && (
            <div className="my-3">
              {" "}
              <span className="grp_baner_selected_img_container">
                <img
                  src={selectedImg.url}
                  className="grp_baner_selected_img_preview"
                />
                <span
                  className="flaticon-trash"
                  onClick={() => removeBannerImg()}
                />
              </span>{" "}
            </div>
          )}
        </div>

        <div>
          {(!searching || imagePage > 1) && apiGiphys && apiGiphys.length ? (
            <div
              className="grp_baner_modal_image_container"
              style={{
                maxHeight: "none",
              }}
            >
              {renderGiphysPreview(apiGiphys, selectedImg)}
            </div>
          ) : (
            <div className="d-flex justify-content-center">
              <img src={Spinner} height="100px" width="100px" />
            </div>
          )}
        </div>
      </div>
    );
  };
  const getUploadUi = () => {
    const uploadedDoc =
      selectedMedia[0] &&
      selectedMedia[0].type &&
      selectedMedia[0].url &&
      (selectedMedia[0].uploaded || selectedMedia[0].url.indexOf("aws.com") > 0)
        ? selectedMedia[0]
        : null;

    return (
      <div
        style={{
          display: "contents",
          flexDirection: "column",
        }}
      >
        {uploadedDoc ? (
          <div>
            {uploadedDoc.type.indexOf("video") > -1 ? (
              <span className="grp_baner_selected_img_container">
                <ReactPlayer
                  url={uploadedDoc.url}
                  controls={true}
                  height={"100px"}
                  width="100px"
                />

                <span
                  className="flaticon-trash"
                  onClick={() => removeBannerImg()}
                />
              </span>
            ) : (
              <span className="grp_baner_selected_img_container">
                <img
                  src={uploadedDoc.url}
                  className="grp_baner_selected_img_preview"
                />
                <span
                  className="flaticon-trash"
                  onClick={() => removeBannerImg()}
                />
              </span>
            )}
          </div>
        ) : (
          ""
        )}
        <label
          htmlFor="grp_banner_img_upload_btn"
          className="trivia_upload_popup_upload_ui cursor-pointer"
        >
          <div>
            <span
              style={{
                textDecoration: "underline",
              }}
            >
              Upload
            </span>{" "}
            or drop an image right here.
          </div>
          <input
            id="grp_banner_img_upload_btn"
            onChange={fileSelectedHandler}
            type="file"
          />

          <div className="trivia_upload_popup_upload_ui_help_text">
            JPG, PNG, or GIF.
          </div>
        </label>
      </div>
    );
  };
  const getVideosUi = () => {
    const selectedVid =
      selectedMedia[0] &&
      !selectedMedia[0].uploaded &&
      selectedMedia[0].type &&
      selectedMedia[0].type.indexOf("video") > -1
        ? selectedMedia[0]
        : null;
    return (
      <div>
        <div className="mb-3">
          <InputGroup>
            <InputGroupAddon
              addonType="prepend"
              className="input_img_vid_search_preprend"
            >
              <BiSearch />
            </InputGroupAddon>
            <Input
              placeholder={` Search "engineer", "professional", "manager", etc `}
              value={videoSearchInput}
              onChange={(e) => {
                setVideoSearchInput(e.target.value);
                if (e.target.value.trim()) {
                  debounceSearchVideos(e.target.value, 1);
                }
              }}
            />
          </InputGroup>

          {selectedVid && (
            <div className="my-3">
              {" "}
              <span className="grp_baner_selected_img_container">
                <ReactPlayer
                  url={selectedVid.url}
                  controls={true}
                  height={"100px"}
                  width="100px"
                />
                <span
                  className="flaticon-trash"
                  onClick={() => removeBannerImg()}
                />
              </span>{" "}
            </div>
          )}
        </div>

        <div>
          {(!searching || imagePage > 1) && apiVideos && apiVideos.length ? (
            <Row>
              {apiVideos.map((video, idx) => {
                let video_url = "";
                let video_doc = video.video_files
                  ? video.video_files.find((x) => x.quality == "hd")
                  : null;

                if (video_doc) {
                  video_url = video_doc.link;
                }

                if (!video_url && video.video_files) {
                  video_url = video.video_files[0].link;
                  video_doc = video.video_files[0];
                }
                const isSelected = selectedVid && selectedVid.url == video_url;
                return (
                  <Col sm={6} className="py-3" key={idx}>
                    <div
                      className={`trivia-upload-list-item ${
                        isSelected ? "selected" : ""
                      } trivia-video-tile`}
                      onClick={() => urlSelectHandlerVideo(video_doc)}
                    >
                      <ReactPlayer
                        url={video_url}
                        controls={true}
                        height={"200px"}
                        width="100%"
                      />
                      <CheckBox
                        className="grp_baner_modal_image_checkbox"
                        checked={selectedVid && selectedVid.url == video_url}
                        type="checkbox"
                        onClick={() => {
                          urlSelectHandlerVideo(video_doc);
                        }}
                        style={{
                          top: "12px",
                          left: "14px",
                        }}
                      />
                      <div className="grp_baner_modal_image_item_details">
                        <span className="grp_baner_modal_image_item_details_title"></span>
                        <span className="grp_baner_modal_image_item_details_author">
                          {video.user && video.user.name}
                        </span>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <div className="d-flex justify-content-center">
              <img src={Spinner} height="100px" width="100px" />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="survey-top-div">
      <Modal isOpen={open} className="bwai-edit-modal bwai-edit-media-modal">
        <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
          Upload Media
        </ModalHeader>
        <ModalBody className="p-0">
          <div>
            <div className="trivia_upload_popup_tabs_list">
              <span
                className={`${
                  tab == 1
                    ? "trivia_upload_popup_tab_item_active"
                    : "trivia_upload_popup_tab_item"
                }`}
              >
                <a onClick={() => changeTab(1)}>Upload</a>
              </span>
              <span
                className={`${
                  tab == 2
                    ? "trivia_upload_popup_tab_item_active"
                    : "trivia_upload_popup_tab_item"
                }`}
              >
                <a onClick={() => changeTab(2)}>Image</a>
              </span>
              <span
                className={`${
                  tab == 4
                    ? "trivia_upload_popup_tab_item_active"
                    : "trivia_upload_popup_tab_item"
                }`}
              >
                <a onClick={() => changeTab(4)}>Giphy</a>
              </span>

              <span
                className={`${
                  tab == 3
                    ? "trivia_upload_popup_tab_item_active"
                    : "trivia_upload_popup_tab_item"
                }`}
              >
                <a onClick={() => changeTab(3)}>Video</a>
              </span>
            </div>
          </div>
          <div className="trivia_upload_popup_tab_content_body">
            {tab === 1
              ? getUploadUi()
              : tab === 2
              ? getPhotosUi()
              : tab === 3
              ? getVideosUi()
              : tab === 4
              ? getGiphyUI()
              : ""}
          </div>
        </ModalBody>
        {tab !== 1 && !searching && (
          <ModalFooter>
            <Button
              className="mt-4 w-100 bwai-edit-load-more"
              onClick={() => {
                if (tab == 2) {
                  if (imageSearchInput) {
                    getImages(imageSearchInput, imagePage + 1);
                  } else {
                    preloadPopularImages(null, imagePage + 1);
                  }
                  setImagePage(imagePage + 1);
                }
                if (tab == 3) {
                  if (videoSearchInput) {
                    getVideos(videoSearchInput, videoPage + 1);
                  } else {
                    preloadPopularVideos(null, videoPage + 1);
                  }
                  setVideoPage(videoPage + 1);
                }
                if (tab == 4) {
                  if (giphySearchInput) {
                    getGifs(giphySearchInput, giphyPage + 1);
                  } else {
                    preloadPopularGifs(null, giphyPage + 1);
                  }

                  setGiphyPage(giphyPage + 1);
                }
              }}
            >
              Load more
            </Button>
          </ModalFooter>
        )}
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    preloadedImages: state.trivia.popularImages,
    preloadedVideos: state.trivia.popularVideos,
    preloadedGiphys: state.trivia.popularGifs,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPopularImages: (data) => dispatch(actionCreators.setPopularImages(data)),
    setPopularVideos: (data) => dispatch(actionCreators.setPopularVideos(data)),
    setPopularGifs: (data) => dispatch(actionCreators.setPopularGifs(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadMediaModal);
